/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  if (window.location.href.indexOf('cart') > -1) {
    window.location.href = '/';
  }

   var path = window.location.pathname;

    if (path.includes('/products/christmas-bandana-free-gift')) {
      window.location.href = '/products/christmas-bandana';
    }

    if (path.includes('/products/christmas-ornament-free-gift')) {
      window.location.href = '/products/staffy-christmas-ornament';
    }

    if (path.includes('/products/holiday-stocking-free-gift')) {
      window.location.href = '/products/christmas-stocking';
    }

  // Check if URL has ?freetoy parameter
  const urlParams = new URLSearchParams(window.location.search);
  const hasFreeToyCoupon = urlParams.has('freetoy');
  const giftLineItem = document.querySelectorAll('[data-freetoy-gift]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();

    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;


    formData.append('id', 47382751707386); // Free toy variant ID
    formData.append('quantity', 1);
    //document.querySelectorAll('.reward-block')[0].classList.add('reward-block--selectedd')

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          freeGift: true,
          giftFormData: formData,
        },
        bubbles: false,
      })
    );
  }

  // Init Yotpo back in stock
  window.addEventListener('theme:variant:change', (e) => {
    if (window.smsBumpBackInStock) {
      window.smsBumpBackInStock.changeSelectedVariant(e.detail.variant.id);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




// Check if user has manually turned it off before
const userDisabled = localStorage.getItem('upcartSwitchDisabled') === 'true';

if (!userDisabled) {
  const checkInterval = setInterval(() => {

    const upcart = document.querySelector('#upCart');
    if (!upcart) return;

    
    // Access the shadow root
    const shadow = upcart.shadowRoot;
    if (!shadow) return;

    // Find the toggle switch inside the shadow root
    const toggle = shadow.querySelector('.styles_ToggleSwitch__');
    if (!toggle) return;

    // Detect if it's already active (has --active class)
    const isActive = toggle.classList.contains('styles_ToggleSwitch--active__');
    console.log('upcart');
    console.log(toggle.innerHTML)
    
    if (!isActive) {
      console.log('✅ Auto-activating UpCart switch');
       setTimeout(function(){ 
 toggle.click(); // simulate user click
}, 2000);
     
    }
    else{
      console.log('✅ SAuto-activating UpCart switch!!');
      setTimeout(function(){ 
        var toggled = shadow.querySelector('.styles_ToggleSwitch__');
    // Detect if it's already active (has --active class)
    console.log('toggled' + toggled.classList);
    var isActived = toggled.classList.contains('styles_ToggleSwitch--active__');
        if(!isActived){
            toggle.click(); // simulate user click
        }
      
      }, 1000);
      setTimeout(function(){ 
        var toggled = shadow.querySelector('.styles_ToggleSwitch__');
    // Detect if it's already active (has --active class)
    console.log('toggled' + toggled.classList);
    var isActived = toggled.classList.contains('styles_ToggleSwitch--active__');
        if(!isActived){
            toggle.click(); // simulate user click
        }
      
      }, 1500);
      
       setTimeout(function(){ 
        var toggled = shadow.querySelector('.styles_ToggleSwitch__');
    // Detect if it's already active (has --active class)
    console.log('toggled' + toggled.classList);
    var isActived = toggled.classList.contains('styles_ToggleSwitch--active__');
        if(!isActived){
            toggle.click(); // simulate user click
        }
      
      }, 2000);

      setTimeout(function(){ 
        var toggled = shadow.querySelector('.styles_ToggleSwitch__');
    // Detect if it's already active (has --active class)
    console.log('toggled' + toggled.classList);
    var isActived = toggled.classList.contains('styles_ToggleSwitch--active__');
        if(!isActived){
            toggle.click(); // simulate user click
        }
      
      }, 3000);
    }
    clearInterval(checkInterval);
  }, 300);
}

// Watch for manual user toggle (using event delegation in shadow root)
const observeUpCart = setInterval(() => {
  const upcart = document.querySelector('#upCart');
  if (!upcart || !upcart.shadowRoot) return;

  clearInterval(observeUpCart);

  const shadow = upcart.shadowRoot;

  shadow.addEventListener('click', (e) => {
    const toggle = e.target.closest('.styles_ToggleSwitch__');
    if (!toggle) return;

    const isActive = toggle.classList.contains('styles_ToggleSwitch--active__');
    if (isActive) {
      localStorage.removeItem('upcartSwitchDisabled');
      console.log('🔄 UpCart switch manually turned ON by user');
    } else {
      localStorage.setItem('upcartSwitchDisabled', 'true');
      console.log('🚫 UpCart switch manually turned OFF by user');
    }
  });
}, 300);